var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M25.375 21H2.625C1.17523 21 0 19.8248 0 18.375V2.625C0 1.17523 1.17523 0 2.625 0H25.375C26.8248 0 28 1.17523 28 2.625V18.375C28 19.8248 26.8248 21 25.375 21ZM6.125 3.0625C4.43363 3.0625 3.0625 4.43363 3.0625 6.125C3.0625 7.81637 4.43363 9.1875 6.125 9.1875C7.81637 9.1875 9.1875 7.81637 9.1875 6.125C9.1875 4.43363 7.81637 3.0625 6.125 3.0625ZM3.5 17.5H24.5V11.375L19.714 6.58902C19.4578 6.33276 19.0422 6.33276 18.7859 6.58902L11.375 14L8.33902 10.964C8.08276 10.7078 7.66724 10.7078 7.41092 10.964L3.5 14.875V17.5Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadbg);
export default __webpack_public_path__ + "static/media/uploadbg.3d673c972ad660cb29e49f03b52001e7.svg";
export { ForwardRef as ReactComponent };